/** On-screen invoice document width (~US Letter/A4), capped to viewport on small screens. */
export const INVOICE_DOCUMENT_MAX_WIDTH_CLASS = "max-w-full sm:max-w-[210mm]";

export const invoiceDocumentOuterClass = `mx-auto w-full ${INVOICE_DOCUMENT_MAX_WIDTH_CLASS} pb-8`;

export const invoiceDocumentArticleClass =
  "light relative overflow-hidden rounded-lg border bg-white text-foreground shadow-sm sm:shadow-sm";

export const invoiceDocumentInnerClass = "p-4 sm:p-8 md:p-10";
